module.exports = __webpack_public_path__ + "img/banner_RSV_text.40a5a46a.webp";